/* Progressive enhancement only: native GET selection and Shopify POST forms work without JS. */
(() => {
  'use strict';
  const initProduct = (root) => {
    if (root.dataset.productEnhanced === 'true') return;
    root.dataset.productEnhanced = 'true';
    const selector = root.querySelector('[data-product-variant]');
    const variantId = root.querySelector('[data-product-variant-id]');
    const addButton = root.querySelector('[data-product-add]');

    if (selector && variantId && addButton) {
      const updateVariant = (updateUrl = true) => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        variantId.value = option.value;
        const setText = (query, text) => {
          const target = root.querySelector(query);
          if (target) target.textContent = text || '';
        };
        setText('[data-product-price]', option.dataset.price);
        setText('[data-product-color]', option.dataset.color);
        setText('[data-selected-variant]', option.dataset.title);
        setText('[data-product-availability]', available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel);
        addButton.disabled = !available || addButton.dataset.purchaseBlocked === 'true';
        addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.unavailableLabel;

        const quantity = root.querySelector('[data-product-quantity]');
        if (quantity) {
          const min = Math.max(1, Number(option.dataset.quantityMin) || 1);
          const step = Math.max(1, Number(option.dataset.quantityIncrement) || 1);
          const max = Number(option.dataset.quantityMax);
          quantity.min = String(min);
          quantity.step = String(step);
          if (Number.isFinite(max) && max >= min) quantity.max = String(max);
          else quantity.removeAttribute('max');
          const current = Number(quantity.value);
          if (!Number.isFinite(current) || current < min || (current - min) % step !== 0 || (quantity.hasAttribute('max') && current > max)) quantity.value = String(min);
        }

        const primary = root.querySelector('.product-image__zoom');
        const primaryImage = primary && primary.querySelector('.product-image__media');
        if (primary && primaryImage && option.dataset.imageSrc) {
          primaryImage.src = option.dataset.imageSrc;
          primaryImage.removeAttribute('srcset');
          primaryImage.alt = option.dataset.imageAlt || '';
          primary.dataset.src = option.dataset.zoomSrc || option.dataset.imageSrc;
          primary.dataset.alt = primaryImage.alt;
          root.querySelectorAll('[data-gallery-select]').forEach((thumbnail) => {
            const selected = thumbnail.dataset.imageId === option.dataset.imageId;
            thumbnail.classList.toggle('is-active', selected);
            thumbnail.setAttribute('aria-pressed', String(selected));
          });
        }

        if (updateUrl) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState(window.history.state, '', url);
          } catch { /* Selection and native purchase still work without history access. */ }
        }
      };
      selector.addEventListener('change', () => updateVariant());
      root.querySelector('[data-variant-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        updateVariant();
      });
      const applyButton = root.querySelector('[data-variant-apply]');
      const instructions = root.querySelector('[data-variant-instruction]');
      if (applyButton) applyButton.hidden = true;
      if (instructions) instructions.hidden = true;
      updateVariant(false);
    }

    root.querySelectorAll('[data-size-chart]').forEach((chart) => {
      const sourceUnit = chart.dataset.sourceUnit;
      if (sourceUnit !== 'cm' && sourceUnit !== 'in') return;
      const measurements = [...chart.querySelectorAll('[data-chart-value]')].filter((cell) => cell.dataset.chartValue.trim() !== '' && Number.isFinite(Number(cell.dataset.chartValue)));
      if (!measurements.length) return;
      const controls = chart.querySelector('[data-chart-units]');
      if (!controls) return;
      controls.hidden = false;
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('[data-chart-unit]');
        if (!button || !controls.contains(button)) return;
        const unit = button.dataset.chartUnit;
        if (unit !== 'cm' && unit !== 'in') return;
        measurements.forEach((cell) => {
          const original = Number(cell.dataset.chartValue);
          const converted = unit === sourceUnit ? original : sourceUnit === 'cm' ? original / 2.54 : original * 2.54;
          cell.textContent = unit === sourceUnit ? cell.dataset.chartValue : String(Math.round(converted * 10) / 10);
        });
        controls.querySelectorAll('[data-chart-unit]').forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
        const label = chart.querySelector('[data-chart-unit-label]');
        if (label) label.textContent = unit;
      });
    });
  };
  const init = (scope = document) => {
    if (scope.matches?.('[data-heir-product]')) initProduct(scope);
    scope.querySelectorAll('[data-heir-product]').forEach(initProduct);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
